import { apiErrorFromResponse } from './errors';

// Centralized API endpoints
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export const API = {
  // User-related endpoints
  LOGIN: `${BASE_URL}/api/users/login`,
  REGISTER: `${BASE_URL}/api/users/register`,
  USERS_ME: `${BASE_URL}/api/users/me`,
  CHANGE_PASSWORD: `${BASE_URL}/api/users/change-password`,
  REQUEST_RESET_PASSWORD: `${BASE_URL}/api/users/request-reset-password`,
  RESET_PASSWORD: `${BASE_URL}/api/users/reset-password`,
  UPDATE_ACCOUNT: `${BASE_URL}/api/users/update-account`,
  PASSWORDLESS_REGISTER: `${BASE_URL}/api/users/passwordless-register`,

  // Purchase-related endpoints
  REDEEM: `${BASE_URL}/api/purchase/redeem`,
  INITIATE_PURCHASE: `${BASE_URL}/api/purchase/initiate`,
  INITIATE_MULTIPLE_SINGLE_PURCHASE: `${BASE_URL}/api/purchase/initiate-multi-single`,
  INITIATE_SURVEY_UNLOCK: `${BASE_URL}/api/purchase/initiate-survey-unlock`,

  GET_PURCHASE_BY_SESSION_ID: `${BASE_URL}/api/purchase/session`,
  SURVEY_UNLOCK_STATUS: `${BASE_URL}/api/purchase/survey-unlock-status`,
  MY_PURCHASES: `${BASE_URL}/api/purchase/my-purchases`,
  MY_REDEMPTIONS: `${BASE_URL}/api/purchase/my-redemptions`,
  MY_ACCESS: `${BASE_URL}/api/purchase/my-access`,

  // Survey-related endpoints
  GET_SURVEY_LINK: `${BASE_URL}/api/survey/survey-link`,
  MY_SURVEY_RESULTS: `${BASE_URL}/api/survey/my-survey-results`,
  SAVE_RESPONSES: `${BASE_URL}/api/survey/responses`,
  // Anonymous survey endpoints
  ANON_SURVEY: `${BASE_URL}/api/anon-survey`,
  ANON_SURVEY_BRIEF: `${BASE_URL}/api/anon-survey/brief`,
  // Anonymous temp survey endpoints (no login)
  ANON_SURVEY_TEMP: `${BASE_URL}/api/anon-survey/temp`,
  ANON_SURVEY_TEMP_INITIATE_PURCHASE: `${BASE_URL}/api/anon-survey/temp/initiate-purchase`,
  // Claim endpoint to convert anon claim to a user-linked survey result
  CLAIM: `${BASE_URL}/api/claim`,

  // Admin-related endpoints
  ADMIN_USERS: `${BASE_URL}/api/admin/users`,
};

// Generic API request function with JWT support
export async function apiRequest(
  url,
  { method = 'GET', body, token, headers = {} } = {},
) {
  const fetchHeaders = { ...headers }; // Start with provided headers

  // Only set Content-Type for requests with a body
  if (body) {
    fetchHeaders['Content-Type'] = 'application/json';
  }

  if (token) {
    fetchHeaders['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    method,
    headers: fetchHeaders,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    // Security: do not read/propagate backend error bodies to the UI.
    throw apiErrorFromResponse(response, 'apiRequest');
  }
  return response;
}
